<template>
  <div class="big">
    <div class="page_title">健康商城-商品管理</div>
    <div style="padding:20px;border-radius:5px;">
      <div class="container">
        <div>
          <el-menu
            :default-active="activeIndex"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
          >
            <el-menu-item
              index="1"
              style="font-size:16px"
            >商品分组</el-menu-item>
            <el-menu-item
              index="2"
              style="font-size:16px"
            >商品列表</el-menu-item>
          </el-menu>
        </div>
        <div class="box">
          <div class="component">
            <component :is="currentComponent" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Group from './Group';
import List from './List';

export default {
  data() {
    return {
      activeIndex: '1',
      active: ''
    };
  },
  computed: {
    currentComponent() {
      switch (this.active) {
        case '1':
          return Group;
        case '2':
          return List;
        default:
          return Group;
      }
    }
  },
  methods: {
    handleSelect(key, keyPath) {
      this.active = key;
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}

.box {
  width: 100%;
  box-sizing: border-box;

  .component {
    width: 100%;
    box-sizing: border-box;
  }
}
</style>
